import { Modal } from "react-bootstrap";

import useMiscUIStore from "../../stores/miscUIStore";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

function LoadingModal({ centered = true }) {
  const show = useMiscUIStore((s) => s.showLoadingModal);

  return (
    <Modal show={show} centered={centered}>
      <Modal.Body style={{ height: "15rem", width: "30rem" }}>
        <div className="d-flex justify-content-center align-items-center w-100 h-100">
          <LoadingSpinner />
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default LoadingModal;
